var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "failure",
    fill: "#EF6E64",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Background"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C31.045695,-2.02906125e-15 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 1.3527075e-15,31.045695 0,20 C-1.3527075e-15,8.954305 8.954305,2.02906125e-15 20,0 Z M9.76842105,8.88421053 L8.44210526,10.2105263 C8.06315789,10.5894737 8.06315789,11.1578947 8.44210526,11.5368421 L16.7157895,19.8105263 C16.968421,20.0631579 16.968421,20.4421053 16.7157895,20.6947368 L8.37894737,29.0315789 C8,29.4105263 8,29.9789474 8.37894737,30.3578947 L9.70526316,31.6842105 C10.0842105,32.0631579 10.6526316,32.0631579 11.0315789,31.6842105 L19.3684211,23.4105263 C19.6210526,23.1578947 20,23.1578947 20.2526316,23.4105263 L28.5263158,31.6842105 C28.9052632,32.0631579 29.4736842,32.0631579 29.8526316,31.6842105 L31.1789474,30.3578947 C31.5578947,29.9789474 31.5578947,29.4105263 31.1789474,29.0315789 L22.9052632,20.7578947 C22.7157895,20.5052632 22.7157895,20.1263158 22.9052632,19.8736842 L31.1789474,11.6 C31.5578947,11.2210526 31.5578947,10.6526316 31.1789474,10.2736842 L29.8526316,8.94736842 C29.4736842,8.56842105 28.9052632,8.56842105 28.5263158,8.94736842 L20.2526316,17.2210526 C20,17.4736842 19.6210526,17.4736842 19.3684211,17.2210526 L11.0947368,8.88421053 C10.7157895,8.50526316 10.1473684,8.50526316 9.76842105,8.88421053 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.9bfe74f33dadea900b68c72f79b63e92.svg";
export { ForwardRef as ReactComponent };